import React from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { PainAgitation } from './components/PainAgitation';
import { Mechanism } from './components/Mechanism';
import { AboutLorena } from './components/AboutLorena';
import { OfferStack } from './components/OfferStack';
import { DiagnosticSection } from './components/DiagnosticSection';
import { Testimonials } from './components/Testimonials';
import { ForWhom } from './components/ForWhom';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-navy selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <StickyHeader data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainAgitation data-id="element-4" />
        <Mechanism data-id="element-5" />
        <AboutLorena data-id="element-6" />
        <OfferStack data-id="element-7" />
        <DiagnosticSection data-id="element-8" />
        <Testimonials data-id="element-9" />
        <ForWhom data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
      <FloatingCTA data-id="element-14" />
    </div>;
}